import React, { useState } from 'react'
import { GoogleMap, Marker, InfoWindow, useLoadScript } from '@react-google-maps/api'
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { useLocation } from 'react-router-dom'

// Define libraries as a constant outside the component
const libraries: ('places')[] = ['places']

const center = {
  lat: 37.970833,
  lng: 23.72611,
}

function MapComponent({ zooms = 7, data = [] }: any) {
  const [selectedMarker, setSelectedMarker] = useState<any>(null)

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: 'AIzaSyD32soTrhrAXzmKQp7rH8NsL8NQMhmdqlY',
    libraries,
  })

  const { pathname } = useLocation()

  const containerStyle = {
    width: pathname.includes('collect-orders') ? '800px' : '100%',
    height: pathname.includes('collect-orders') ? '600px' : '700px',
  }

  // Transform data to include both customer and centre locations
  const markers: any[] = []

  data.forEach((item: any, index: number) => {
    // Add customer marker if available
    const customerLat = item.customerInfo?.address?.latitute
    const customerLng = item.customerInfo?.address?.longitute

    if (customerLat && customerLng && customerLat !== 0 && customerLng !== 0) {
      markers.push({
        id: `customer-${index}`,
        lat: customerLat,
        lng: customerLng,
        name: item.customerInfo.name || 'Unknown Customer',
        street: item.customerInfo.address.street || 'No address',
        type: 'customer',
        icon: '/icons8-man-64.png'
      })
    }

    // Add centre marker if available
    const centreLat = item.centreInfo?.address?.latitute
    const centreLng = item.centreInfo?.address?.longitute

    if (centreLat && centreLng && centreLat !== 0 && centreLng !== 0) {
      markers.push({
        id: `centre-${index}`,
        lat: centreLat,
        lng: centreLng,
        name: item.centreInfo.name || 'Unknown Centre',
        street: item.centreInfo.address.street || 'No address',
        type: 'centre',
        icon: '/mapIcon.png'
      })
    }
  })

  const mapCenter = markers.length > 0
    ? { lat: markers[0].lat, lng: markers[0].lng }
    : center

  if (!isLoaded) return <div>Loading...</div>
  if (loadError) return <div>Error loading maps</div>

  return (
    <div className='App'>
      <GoogleMap
        mapContainerStyle={containerStyle}
        mapContainerClassName='map-container'
        center={mapCenter}
        zoom={zooms}
      >
        {markers.map((marker: any) => (
          <Marker
            key={marker.id}
            position={{ lat: marker.lat, lng: marker.lng }}
            icon={marker.icon}
            onClick={() => setSelectedMarker(marker)}
          />
        ))}

        {selectedMarker && (
          <InfoWindow
            position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
            onCloseClick={() => setSelectedMarker(null)}
          >
            <div style={{
              padding: '10px',
              minWidth: '200px',
              fontFamily: 'Arial, sans-serif'
            }}>
              {/* <div style={{
                display: 'inline-block',
                padding: '4px 8px',
                backgroundColor: selectedMarker.type === 'customer' ? '#ffebee' : '#e3f2fd',
                color: selectedMarker.type === 'customer' ? '#c62828' : '#1565c0',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: '600',
                marginBottom: '8px',
                textTransform: 'uppercase'
              }}>
                {selectedMarker.type === 'customer' ? 'Customer' : 'Centre'}
              </div> */}
              <h4 style={{
                margin: '0 0 8px 0',
                fontSize: '16px',
                fontWeight: '600',
                color: '#333'
              }}>
                {selectedMarker.name}
              </h4>
              <p style={{
                margin: 0,
                fontSize: '14px',
                color: '#666',
                lineHeight: '1.4'
              }}>
                {selectedMarker.street}
              </p>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  )
}

export default MapComponent